import { FC } from 'react';
import { useGlobalErrorStore } from './store';

import styles from './styles.module.css';

export const GlobalErrorBanner: FC = () => {
    const message = useGlobalErrorStore((state) => state.message);
    const clearError = useGlobalErrorStore((state) => state.clearError);

    if (!message) {
        return null;
    }

    return (
        <div className={styles.banner}>
            <span className={styles.message}>{message}</span>
            <button type={'button'} className={styles.close} onClick={clearError} aria-label={'Закрыть'}>
                ×
            </button>
        </div>
    );
};
